document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 990) return;

  const menu = document.querySelector('.header__inline-menu');
  if (!menu) return;

  const items = menu.querySelectorAll('details.mega-menu');

  items.forEach((item) => {
    const summary = item.querySelector('summary');

    item.addEventListener('mouseenter', function () {
      items.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.removeAttribute('open');
          const otherSummary = otherItem.querySelector('summary');
          if (otherSummary) otherSummary.setAttribute('aria-expanded', 'false');
        }
      });

      item.setAttribute('open', '');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    });

    item.addEventListener('mouseleave', function () {
      item.removeAttribute('open');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });

    if (summary) {
      summary.addEventListener('click', function (event) {
        if (window.innerWidth >= 990) {
          event.preventDefault();
        }
      });
    }
  });
});